module.exports = __webpack_public_path__ + "static/media/btn-cancel@2x.1dfe76b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/btn-cancel@2x.png
// module id = 331
// module chunks = 0